const App = {
  preLoading: () => {
    $(window).on("load", function () {
      $(".loader-container").fadeOut(1000);
    });
  },
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.SetBackground();
    App.preLoading();
  },
};

function InitSlider() {
  new Swiper(".popular-product-slider .swiper-container", {
    speed: 1e3,
    slidesPerView: 4,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".popular-product-slider .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
    navigation: {
      clickable: !0,
      nextEl: ".popular-product-slider .swiper-next",
      prevEl: ".popular-product-slider .swiper-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 1,
      },
    },
  });
  new Swiper(".other-products .swiper-container", {
    speed: 1e3,
    slidesPerView: 4,
    spaceBetween: 30,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".other-products .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
    navigation: {
      clickable: !0,
      nextEl: ".other-products .swiper-next",
      prevEl: ".other-products .swiper-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 1,
      },
    },
  });

  var galleryThumbs = new Swiper(".planar-control__slider .gallery-thumbs", {
    spaceBetween: 0,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    on: {
      slideChangeTransitionStart: function () {
        $(".planar-control__slider .gallery-thumbs .title").hide(0);
        $(".planar-control__slider .gallery-thumbs .title")
          .removeClass("animation")
          .removeClass("animate");
      },
      slideChangeTransitionEnd: function () {
        $(".planar-control__slider .gallery-thumbs .title").show(0);
      },
    },
  });
  var galleryTop = new Swiper(".planar-control__slider .gallery-top", {
    spaceBetween: 10,
    slidesPerView: 1,
    thumbs: {
      swiper: galleryThumbs,
    },
  });

  new Swiper(".industries-section .swiper-container", {
    speed: 1e3,
    slidesPerView: 6,
    spaceBetween: 10,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },
    },
  });
  new Swiper(".project-detail__slider .swiper-container", {
    speed: 1e3,
    slidesPerView: 1,
    spaceBetween: 35,
    autoplay: {
      delay: 5000,
    },
    loopedSlides: 20,
    loop: true,
    pagination: {
      el: ".project-detail__slider .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
    navigation: {
      clickable: !0,
      nextEl: ".project-detail__slider .swiper-next",
      prevEl: ".project-detail__slider .swiper-prev",
    },
  });

  var galleryThumbs = new Swiper(".product-detail .gallery-thumbs", {
    spaceBetween: 15,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  });
  var galleryTop = new Swiper(".product-detail .gallery-top", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".product-detail .swiper-next",
      prevEl: ".product-detail .swiper-prev",
    },
    thumbs: {
      swiper: galleryThumbs,
    },
  });

  $(window).on("resize", function () {
    if ($(window).width() < 768) {
      new Swiper(".home-gallery .swiper-container", {
        speed: 1e3,
        slidesPerView: 1,
        spaceBetween: 20,
        autoplay: {
          delay: 3000,
        },
      });
    }
  });
}
$(document).ready(function () {
  App.Init();
  toggleMenu();
  InitSlider();
  Headers();
  animationScroll();
  aboutTabs();
  adjustProductAmount();
  checkboxForm();
  paymentCheck();
  featuresAccordion();
  navMobile();
  productList();
  productDetailAccordion();
  rangeSlide();
  cateFilter();

  $(".product-detail .box-img .img").fancybox({
    toolbar: false,
    smallBtn: true,
    showNavArrows: true,
    width: 940,
    height: 540,
  });
  $(".fancybox-button").empty();

  $(window).on("resize", function () {
    $("header .navbar-mobile").removeClass("active");
    $("body").removeClass("over-hidden");
    $(".back-drop").removeClass("active");
    $(".toggle-btn").removeClass("active");
  });
  var moveNav = new MappingListener({
    selector: "header .menu",
    mobileWrapper: ".navbar-mobile",
    mobileMethod: "appendTo",
    desktopWrapper: "header .logo",
    desktopMethod: "insertAfter",
    breakpoint: 1200,
  }).watch();
});
// accordion
function productList() {
  $(".sidebar .is-open .nav-link").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".nav-sub").slideUp(200);
      $(".sidebar .is-open .nav-link em")
        .removeClass("mdi-minus")
        .addClass("mdi-plus");
    } else {
      $(".sidebar .is-open .nav-link em")
        .removeClass("mdi-minus")
        .addClass("mdi-plus");
      $(this).find("em").removeClass("mdi-plus").addClass("mdi-minus");
      $(".sidebar .is-open .nav-link").removeClass("active");
      $(this).addClass("active");
      $(".nav-sub").slideUp(200);
      $(this).siblings(".nav-sub").slideDown(200);
    }
  });
}
function toggleMenu() {
  $(".toggle-btn").on("click", function () {
    $(".toggle-btn").toggleClass("active");
    $(".navbar-mobile").toggleClass("active");
    $(".back-drop").toggleClass("active");
    $("body").toggleClass("over-hidden");
  });
  $(".back-drop").on("click", function () {
    $(".toggle-btn").removeClass("active");
    $(".navbar-mobile").removeClass("active");
    $(".back-drop").removeClass("active");
    $("body").removeClass("over-hidden");
  });
}
function Headers() {
  $(window).scroll(function () {
    if ($(window).scrollTop() >= 200) {
      $(".header").addClass("fixed");
    } else {
      $(".header").removeClass("fixed");
    }
  });
}
function animationScroll() {
  $(window).on("scroll", function e() {
    var i = $(window).scrollTop() + $(window).height(),
      t = $(".animatable");
    0 == t.length && $(window).off("scroll", e),
      t.each(function (e) {
        var t = $(this);
        t.offset().top + t.height() - 20 < i &&
          t.removeClass("animatable").addClass("animated");
      });
  }),
    $(window).trigger("scroll");
}

function aboutTabs() {
  // Show the first tab and hide the rest
  $(".us-apart #tabs-nav li:first-child").addClass("active");
  $(".us-apart .tab-content").hide();
  $(".us-apart .tab-content:first").show();
  // Click function
  $(".us-apart #tabs-nav li").click(function () {
    $(".us-apart #tabs-nav li").removeClass("active");
    $(this).addClass("active");
    $(".us-apart .tab-content").hide();
    var activeTab = $(this).find("a").attr("href");
    $(activeTab).fadeIn();
    return false;
  });
}
function adjustProductAmount() {
  $(".plus").click(function () {
    if ($(this).prev().val() < 10) {
      $(this)
        .prev()
        .val(+$(this).prev().val() + 1);
    }
  });
  $(".minus").click(function () {
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1)
        $(this)
          .next()
          .val(+$(this).next().val() - 1);
    }
  });
}
function checkboxForm() {
  $(".custom-checkbox").click(function () {
    $(this).toggleClass("active");
    $(".form-different-address .form-2").toggleClass("active");
  });
}
function paymentCheck() {
  $(".select-group input[type='radio']").click(function () {
    $(".select-group input[type='radio']").each(function () {
      if ($(this).is(":checked")) {
        $(this).parents(".payment-method").css("background", "#f2f2f2");
      } else {
        $(this).parents(".payment-method").css("background", "none");
      }
    });
  });
}
function featuresAccordion() {
  $(".features-accordion .list-item .item .title").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".content").slideUp(200);
      $(".features-accordion .list-item .item .title em")
        .removeClass("mdi-plus")
        .addClass("mdi-minus");
    } else {
      $(".features-accordion .list-item .item .title em")
        .removeClass("mdi-plus")
        .addClass("mdi-minus");
      $(this).find("em").removeClass("mdi-minus").addClass("mdi-plus");
      $(".features-accordion .list-item .item .title").removeClass("active");
      $(this).addClass("active");
      $(".content").slideUp(200);
      $(this).siblings(".content").slideDown(200);
    }
  });
}
function navMobile() {
  if ($(window).width() <= 1200) {
    $(".header .dropdown-icon").on("click", function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".nav-sub").slideUp(200);
        $(".header .dropdown-icon")
          .removeClass("mdi-chevron-up")
          .addClass("mdi-chevron-down");
      } else {
        $(".header .dropdown-icon")
          .removeClass("mdi-chevron-up")
          .addClass("mdi-chevron-down");
        $(this).removeClass("mdi-chevron-down").addClass("mdi-chevron-up");
        $(".header .dropdown-icon").removeClass("active");
        $(this).addClass("active");
        $(".nav-sub").slideUp(200);
        $(this).siblings(".nav-sub").slideDown(200);
      }
    });
  }
}

function productDetailAccordion() {
  $(".product-content-list .list-item .item .title").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".product-content").slideUp(200);
      $(".product-content-list .list-item .item em")
        .removeClass("mdi-minus")
        .addClass("mdi-plus");
      $(".show .text").text("Show Detail");
    } else {
      $(".product-content-list .list-item .item em")
        .removeClass("mdi-minus")
        .addClass("mdi-plus");
      $(this).find("em").removeClass("mdi-plus").addClass("mdi-minus");
      $(".text").text("Show Detail");
      $(this).find(".text").text("Hide Detail");
      $(".product-content-list .list-item .item").removeClass("active");
      $(this).addClass("active");
      $(".product-content").slideUp(200);
      $(this).siblings(".product-content").slideDown(200);
    }
  });
}
function showProducts(minPrice, maxPrice) {
  $(".shop-page .product-list .product-item")
    .hide()
    .filter(function () {
      var price = parseInt($(this).data("price"), 10);
      return price >= minPrice && price <= maxPrice;
    })
    .show();
}
function rangeSlide() {
  var options = {
      range: true,
      min: 10,
      max: 1500,
      values: [10, 1500],
      slide: function (event, ui) {
        var min = ui.values[0];
        var max = ui.values[1];

        $("#priceRangeStart").val("$" + min);
        $("#priceRangeEnd").val("$" + max);
        showProducts(min, max);
      },
    },
    min,
    max;
  $("#price-range").slider(options);
  min = $("#price-range").slider("values", 0);
  max = $("#price-range").slider("values", 1);

  $("#priceRangeStart").val("$" + min);
  $("#priceRangeEnd").val("$" + max);
  showProducts(min, max);
}

function cateFilter() {
  $("#Container").mixItUp({
    load: {
      sort: "order:asc",
    },
    selectors: {
      target: ".mix",
      filter: ".filter",
      sort: ".sort",
    },
    pagination: {
      limit: 10,
      generatePagers: true,
      prevButtonHTML: "previous",
      nextButtonHTML: "next",
    },
    callbacks: {
      onMixStart: function () {
        $(".cd-fail-message").fadeOut(200);
      },
      onMixFail: function () {
        $(".cd-fail-message").fadeIn(200);
      },
    },
  });
  $(function () {
    var $sortSelect = $("#sort"),
      $container = $("#Container");
    $container.mixItUp();
    $sortSelect.on("change", function () {
      $container.mixItUp("sort", this.value);
    });
  });
}
